import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { PostFinanceTradesRequestModel, PostFinanceTradesResponseModel } from "@/features/accounts/finance/services/update-trades-model";

export class UpdateFinanceTradesApi {
  /**
   * 銀行明細更新API
   */
  public updateFinanceTrades = async (
    param: PostFinanceTradesRequestModel
  ): Promise<PostFinanceTradesResponseModel> => {
    const path = `/api/financeaccounts/finances/aggregate`;
    const res = await ApiClient.instance.post<PostFinanceTradesResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
